export default __webpack_public_path__ + "static/media/IMG-20240729-WA0004.2f703a1f.jpg";